$(document).ready(function() {
    // ✅ Safe AOS init
    if (typeof AOS !== 'undefined') {
        AOS.init({
            duration: 2000,
            once: true,
        });

        $(window).on('scroll', function() {
            AOS.refresh();
        });
    }

    // ✅ Smooth Scroll
    if (typeof SmoothScroll !== 'undefined') {
        SmoothScroll({ 
            stepSize: 80,
            animationTime: 500
        });
    }
    
    $(document).on('click', '.collaps-title', function() {
        $(this).parent().toggleClass('act');

    });



});





/* ===== Cart page free-shipping popup ===== */
(function () {
  function initCartShippingPopup() {
    var popup = document.getElementById('cart-shipping-popup');
    if (!popup) return;

    function openPopup() {
      popup.style.display = 'flex';
      document.documentElement.classList.add('cart-popup-open');
    }

    function closePopup() {
      popup.style.display = 'none';
      document.documentElement.classList.remove('cart-popup-open');
    }

    setTimeout(openPopup, 400);

    // Close button
    popup.querySelector('.popup-close').addEventListener('click', closePopup);

    // Click on the dark background closes it
    popup.addEventListener('click', function (e) {
      if (e.target === popup) closePopup();
    });

    // Esc key closes it
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.style.display !== 'none') closePopup();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartShippingPopup);
  } else {
    initCartShippingPopup();
  }
})();